<template>
  <div>
    <div class="mobile">
      <div class="header">
        <div class="title">
          2021投保攻略：重疾险怎么买更划算？
        </div>
        <div class="tags">
          <div class="origin">
            原创
          </div>
          <div class="author" @click="jumpMini">
            骆驼测保
          </div>
          <div class="date">
            一天前
          </div>
        </div>
        <div class="tip">
          <img src="@/assets/articles/arrow-top@2x.png" alt="" />
          点击上方<span>蓝色字</span>，免费一对一咨询
        </div>
        <div class="oval">
          <img src="@/assets/images/directadd/banner@2x.png" alt="" />
        </div>
      </div>
      <div class="content">
        <div class="part-one">
          <div class="part-one-title">一、浏览文章太辛苦？直接咨询更便捷</div>
          <div class="part-one-img" @click="jumpMini">
            <img src="@/assets/images/directadd/part1.png" />
          </div>
          <div class="part-one-cont">
            一旦身患重疾，不但治疗费用昂贵，而且可能因身体原因若干年无法正常工作丧失收入来源，
            给家庭造成重大的经济负担。而重疾险的作用就是抵御重大疾病给我们造成的财务风险。
            那么，重疾险这么好，<span @click="jumpMini"
              >怎么选才好？买的时候要注意什么？</span
            >今天，我们就来好好聊一聊。
          </div>
          <div class="part-one-title">二、文章目录</div>
          <div class="part-one-desc">
            为方便您阅读，可点击切换选读哦～
          </div>
          <div class="part-tow-tabs">
            <md-tabs>
              <md-tab-pane class="content" name="p1" label="买哪种重疾险好？">
                <div class="part-tow-tab-title ct1"></div>
                <div class="part-tow-tab-content">
                  <span>
                    目前在行业内，并没有重疾险类型划分的同一标准。市面上比较常见的是长期重疾险，而一般把长期重疾险分成下面这3类：
                  </span>
                  <p>
                    <span>消费型重疾：</span
                    >保一段时间或者保终身，得了条款约定的疾病，赔一笔钱，没有患病就不赔。
                  </p>
                  <p>
                    <span>储蓄型重疾：</span
                    >保终身，得了条款约定的疾病会赔钱。如果没有患病，身故了也会赔钱。
                  </p>

                  <p>
                    <span>返还型重疾：</span
                    >疾病或身故会赔钱，即便没有疾病或身故，到了一定时间，也会返钱。
                  </p>
                  <img
                    class="tb1-img"
                    src="@/assets/images/directadd/form.png"
                  />
                  <span class="tb1-z">
                    总的来说：
                  </span>
                  <p>
                    <span>如果在乎性价比：</span>
                    建议选择消费型重疾险，价格实惠，一年3000左右也能买到50万保额。
                  </p>
                  <p>
                    <span>如果预算充足：</span>
                    储蓄型重疾险或返还型重疾险动辄一年1万左右，预算充足的话可以考虑。
                  </p>
                </div>
                <div class="part-tow-tab-btn cbtn1" @click="jumpMini">
                  <img
                    src="@/assets/images/directadd/button1@2x.png"
                    width="100%"
                  />
                </div>
              </md-tab-pane>
              <md-tab-pane
                class="content"
                name="p2"
                label="选重疾险，重点关注什么？"
              >
                <div class="part-tow-tab-title ct2"></div>
                <div class="part-tow-tab-content">
                  <span>
                    根据重疾险的特点，我们在挑选重疾险时，应当注意下面几个方面：
                  </span>
                  <p>
                    <span style="display:block">1.保额买多少？</span>
                    重疾险就是为了抵御重大疾病给我们造成的严重经济风险，因此，高保额才能在风险来临之际，起到真正的作用。所以重疾险的保额至关重要！。<br />
                    建议重疾保额至少30万起步，50万标配，预算充足的话，买到100万会更好。
                  </p>
                  <p>
                    <span style="display:block">2.重疾的保障范围怎么选？</span>
                    首先我们不能认为保障范围越广越好。因为高发的28种重疾，银保监局已经规定了必须纳入其中，每个重疾险都有这些疾病，而其他的疾病就更像是锦上添花，大概率覆盖了常见重疾。<br />
                    与其关注病种的多少，不妨关注一下是否有少儿特疾、高龄特疾等。
                  </p>

                  <p>
                    <span style="display:block"
                      >3.重疾险要不要选带身故责任的？</span
                    >
                    很多人都想买带身故责任的重疾险，心想如果没得病身故后也能赔一笔钱更加踏实。但是这种产品的重疾和身故是只能赔一个，而且价格也会贵不少，建议大家慎重考虑。<br />
                    所以如果预算充足，可以买一份保终身带身故的；如果预算有限，想买高保额，消费型重疾险+定期寿险，才是相对合理的选择。
                  </p>
                </div>
                <div class="part-tow-tab-btn cbtn1" @click="jumpMini">
                  <img
                    src="@/assets/images/directadd/button2@2x.png"
                    width="100%"
                  />
                </div>
              </md-tab-pane>
              <md-tab-pane
                class="content"
                name="p3"
                label="经济实用型重疾险榜单"
              >
                <div class="part-tow-tab-title ct3"></div>
                <div class="part-tow-tab-content">
                  <img
                    class="tb1-img"
                    src="@/assets/images/directadd/form2.png"
                  />
                </div>
                <div class="part-tow-tab-btn cbtn1" @click="jumpMini">
                  <img
                    src="@/assets/images/directadd/button3@2x.png"
                    width="100%"
                  />
                </div>
              </md-tab-pane>
            </md-tabs>
          </div>
          <div class="part-one-title">
            三、2021关于“重疾险投保”热搜榜<i class="icon-part-three"></i>
          </div>
          <div class="part-three">
            <div class="part-three-item">
              <div class="part-three-item-no">
                <img src="@/assets/images/directadd/no1.png" />
              </div>
              <div class="part-three-item-text">重疾险要不要带身故？</div>
              <div class="part-three-item-btn" @click="jumpMini">
                1对1免费咨询
              </div>
            </div>
            <div class="part-three-item">
              <div class="part-three-item-no">
                <img src="@/assets/images/directadd/no2.png" />
              </div>
              <div class="part-three-item-text">买重疾险，保额多少才合适？</div>
              <div class="part-three-item-btn" @click="jumpMini">
                1对1免费咨询
              </div>
            </div>
            <div class="part-three-item">
              <div class="part-three-item-no">
                <img src="@/assets/images/directadd/no3.png" />
              </div>
              <div class="part-three-item-text">
                重疾险的保障那么多，生病了到底怎么赔？
              </div>
              <div class="part-three-item-btn" @click="jumpMini">
                1对1免费咨询
              </div>
            </div>
            <div class="part-three-item">
              <div class="part-three-item-no">
                <span>4</span>
              </div>
              <div class="part-three-item-text">
                有了百万医疗险，还要买重疾险吗？
              </div>
              <div class="part-three-item-btn" @click="jumpMini">
                1对1免费咨询
              </div>
            </div>
            <div class="part-three-item">
              <div class="part-three-item-no">
                <span>5</span>
              </div>
              <div class="part-three-item-text">
                买消费型重疾险，没生病钱就白花了？
              </div>
              <div class="part-three-item-btn" @click="jumpMini">
                1对1免费咨询
              </div>
            </div>
            <div class="part-three-item">
              <div class="part-three-item-no">
                <span>6</span>
              </div>
              <div class="part-three-item-text">
                重疾险中的轻症、中症，到底怎么选？
              </div>
              <div class="part-three-item-btn" @click="jumpMini">
                1对1免费咨询
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer" @click="jumpMini"></div>
    <div class="contact-wx" @click="jumpMini"></div>
  </div>
</template>
<script>
import { setCookie, getCookie } from "@/utils/tools";
export default {
  name: "DirectAdd",
  head() {
    return {
      meta: [
        {
          name: "robots",
          content: "noindex,nofollow"
        }
      ]
    };
  },
  metaInfo() {
    return {
      title: "2021投保攻略：重疾险怎么买更划算？"
    };
  },
  data() {
    return {
      semAppId: ""
    };
  },
  created() {
    this.getSemAppIdEvent();
  },
  methods: {
    //获取配置项appId
    getSemAppIdEvent() {
      this.$axios
        .get(
          "/api/insureadmin/commonService/getConfigValue?key=mini_appId_sem",
          {}
        )
        .then(res => {
          if (res.result === 0) {
            this.semAppId = res.data.strValue;
          }
        });
    },
    jumpMini() {
      const url = getCookie(
        this.$route.params.public + "_bdVid_" + this.$route.query.bd_vid
      );
      if (!url) {
        this.$axios
          .post("/api/insurance/urlTransService/generateScheme", {
            miniAppId: this.semAppId,
            jumpWxaDTO: {
              path: "pages/mini/index",
              query: `mp=cebao&bdVid=${this.$route.query.bd_vid ||
                ""}&sourceUrl=${encodeURIComponent(
                window.location.href
              ).replace(/%/g, "@")}`
            }
          })
          .then(res => {
            if (res.result === 0) {
              setCookie(
                this.$route.params.public +
                  "_bdVid_" +
                  this.$route.query.bd_vid,
                res.data,
                1
              );
              window.location.href = res.data;
              this.$router.push({ name: "DaRes" });
            }
          });
      } else {
        window.location.href = url;
        this.$router.push({ name: "DaRes" });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.contact-wx {
  width: 42px;
  height: 44px;
  background-image: url("~@/assets/images/directadd/wx-icon.png");
  background-size: cover;
  position: fixed;
  right: 5px;
  top: 50%;
  z-index: 999;
  animation: scaleAnimate 1s infinite;
}

@-webkit-keyframes scaleAnimate {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
  50% {
    -webkit-transform: scale(1.2);
    transform: scale(1.2);
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
@keyframes scaleAnimate {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
  50% {
    -webkit-transform: scale(1.2);
    transform: scale(1.2);
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
.mobile {
  background: rgba(255, 255, 255, 1);
  margin: 24px 20px;
  box-sizing: border-box;
  min-height: 100%;
  .header {
    text-align: left;
    height: auto !important;
    .title {
      font-size: 20px;
      font-family: PingFangSCBold;
      color: rgba(43, 56, 84, 1);
      line-height: 29px;
    }
    .tags {
      display: flex;
      margin-top: 8px;
      align-content: center;

      div + div {
        margin-left: 14px;
      }
      .origin {
        display: inline-block;
        padding: 0px 8px;
        text-align: center;
        border-radius: 4px;
        opacity: 0.47;
        border: 1px solid #666666;
      }
      .date {
        display: inline-block;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        line-height: 22px;
      }

      .author {
        display: inline-block;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(49, 110, 255, 1);
        line-height: 22px;
      }
    }

    .tip {
      font-size: 12px;
      font-family: PingFangSCBold;
      color: #2b3854;
      line-height: 17px;
      margin-top: 5px;
      margin-left: 75px;
      img {
        display: inline-block;
        width: 14px;
        height: 14px;
        vertical-align: middle;
        margin: 0 5px;
      }
      span {
        color: rgba(49, 110, 255, 1);
      }
    }
    .oval {
      margin-top: 5px;
      img {
        width: 100%;
      }
    }
  }
  .content {
    .part-tow-tab-content {
      line-height: 2;
      p {
        span {
          color: #fd7740;
        }
      }
      .tb1-img {
        width: 98%;
        margin: 25px 0;
      }
      .tb1-z {
        font-size: 16px;
        font-weight: 700;
      }
    }
    .part-tow-tab-title {
      width: 169px;
      height: 27px;
      margin: 10px auto;
      &.ct1 {
        background-image: url("~@/assets/images/directadd/ct1.png");
        background-size: cover;
      }
      &.ct2 {
        width: 299px;
        background-image: url("~@/assets/images/directadd/ct2.png");
        background-size: cover;
      }
      &.ct3 {
        width: 225px;
        background-image: url("~@/assets/images/directadd/ct3.png");
        background-size: cover;
      }
    }
    .part-one {
      margin-top: 25px;
      .part-one-cont {
        text-align: left;
        line-height: 1.5;
        padding: 10px 0;
        span {
          color: rgba(49, 110, 255, 1);
        }
      }
      .part-one-desc {
        font-size: 12px;
        transform: scale(0.83);
        color: #a6a6a6;
        margin-bottom: 10px;
      }
      .icon-part-three {
        display: inline-block;
        width: 16px;
        height: 16px;
        background-image: url("~@/assets/images/directadd/icon-fire@2x.png");
        background-size: cover;
        margin-left: 5px;
      }
      .part-one-title {
        font-size: 16px;
        font-weight: 500;
        color: #2b3854;
        line-height: 24px;
        text-align: center;
      }
      .part-three {
        padding-top: 10px;
        padding-bottom: 25px;
        .part-three-item {
          display: flex;
          display: -webkit-flex;
          font-size: 14px;
          padding: 8px 0;
          border-bottom: 1px solid #e9edf3;
          .part-three-item-no {
            display: -webkit-box;
            display: -webkit-flex;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: center;
            -webkit-align-items: center;
            -ms-flex-align: center;
            align-items: center;
            -webkit-box-pack: center;
            -webkit-justify-content: center;
            -ms-flex-pack: center;
            justify-content: center;
            -webkit-flex-shrink: 0;
            -ms-flex-negative: 0;
            flex-shrink: 0;
            width: 24px;
            height: 24px;
            img {
              width: 100%;
              height: 100%;
            }
            span {
              display: inline-block;
              width: 24px;
              height: 24px;
              line-height: 24px;
              background: #ffd066;
              border-radius: 100%;
              color: #fff;
            }
          }
          .part-three-item-text {
            -webkit-box-flex: 1;
            -webkit-flex: 1;
            -ms-flex: 1;
            flex: 1;
            line-height: 24px;
            font-size: 12px;
            text-align: left;
            margin-left: 3px;
          }
          .part-three-item-btn {
            flex-shrink: 0;
            -webkit-flex-shrink: 0;
            padding: 2px 5px;
            height: 28px;
            border-radius: 20px;
            color: #ff8149;
            border: 1px solid #ff8149;
          }
        }
      }
      .part-one-img {
        margin-top: 15px;
        img {
          width: 100%;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.part-tow-tabs {
  .md-tabs {
    .md-tabs-content {
      .content {
        padding: 15px 0;
        text-align: left;
      }
    }
    .md-tab-bar {
      overflow-x: hidden;
      .md-tab-bar-list {
        width: 110% !important;
        text-align: left;
        .md-tab-bar-item {
          position: relative;
          display: inline-block;
          width: 29%;
          box-sizing: border-box;
          background: #fff5bd;
          color: #fd7740;
          border-radius: 4px;
          font-size: 9px;
          padding: 9px 2px;
          margin-right: 3px;
          line-height: 1;
          text-align: center;
          vertical-align: middle;
          height: 40px;
        }
        .is-active {
          background: #ffd900;
          color: #444;
          box-shadow: 0px 2px 6px 0px rgba(255, 153, 81, 0.5);
          &::after {
            content: "";
            position: absolute;
            left: 50%;
            bottom: -10px;
            -webkit-transform: translateX(-50%);
            -ms-transform: translateX(-50%);
            transform: translateX(-50%);
            border-width: 5px;
            border-style: solid;
            border-color: #ffd900 transparent transparent transparent;
          }
        }
      }
    }
  }
}
.footer {
  display: block;
  width: 100%;
  height: 66px;
  background-image: url("~@/assets/images/directadd/footer.png");
  background-size: cover;
  position: fixed;
  bottom: 0;
  left: 0;
}
</style>
